<div class="view-access-container modal-main">
  <div class="header mt-2 mb-5 w-100">
    <div class="d-flex justify-content-between align-items-center w-100">
      <img src="" />
      <div class="text-center access-point-name d-flex justify-content-between align-items-center">
        <span class="modal-title mb-0"> {{ 'SHARED_ACCESS' | translate }} </span>
      </div>
      <img src="/assets/svg/ico-hamburger-close.svg" class="pointer-cursor" (click)="closeDialog()" />
    </div>
  </div>

  <div class="scroll-container">
    <ng-container *ngFor="let access of sharedAccess; let i = index">
      <ng-container *ngIf="access?.unitName">
        <div class="shared-access-item my-2">
          <div class="d-flex list-view px-3 py-2">
            <div class="d-flex col-md-10">
              <span class="col-3">
                <img src="assets/svg/ico-default-home-circle.svg" alt="ico-building-with-black-circle"
                  class="left-icon" />
              </span>
              <div class="col-9 d-flex flex-column justify-content-center -align-items-center">
                <span class="list-title bold text-capitalize">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ 'UNIT' | translate }}
                    {{ access?.unitPrefix + access?.unitName }}
                  </app-with-tooltip>
                </span>
                <span class="list-description">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ access?.buildingName }}
                  </app-with-tooltip>
                </span>
              </div>
            </div>

            <div class="col-md-2 text-right d-flex flex-row justify-content-around align-items-center "
              (click)="onClickAccess(access)">
              <span class="count">
                <app-with-tooltip [showHelpCursor]="true">{{ access?.userCount }}
                </app-with-tooltip></span>
              <img src="assets/svg/ico-chevron-forward-outline.svg" 
              class="pointer-cursor"
              
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *appHideAccess="commonAccessControl">
        <ng-container *ngIf="access?.accessPointName">
          <div class="shared-access-item my-2">
            <div class="d-flex list-view px-3 py-2">
              <div class="d-flex col-md-10">
                <span class="col-3">
                  <img src="assets/images/accesspoint-icon.png" alt="ico-building-with-black-circle"
                    class="left-icon" />
                </span>
                <div class="col-9 d-flex flex-column justify-content-center -align-items-center">
                  <span class="list-title bold text-capitalize">
                    <app-with-tooltip [showHelpCursor]="true">{{
                      access?.accessPointName
                      }}</app-with-tooltip>
                  </span>
                  <span class="list-description">
                    <app-with-tooltip [showHelpCursor]="true"></app-with-tooltip>
                    {{ access?.buildingName }}
                  </span>
                </div>
              </div>

              <div class="col-md-2 text-right d-flex flex-row justify-content-around align-items-center"
                (click)="onClickAccess(access)">
                <span class="count">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ access?.userCount }}
                  </app-with-tooltip>
                </span>
                <img src="assets/svg/ico-chevron-forward-outline.svg" />
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>